export default __webpack_public_path__ + "static/media/wwr-img.b19f3374.webp";